import { Pipe, PipeTransform } from '@angular/core';
import { Ethnicity } from '../model/patient.model';

@Pipe({
  name: 'patientEthnicity'
})
export class PatientEthnicityPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    const ethnicity: Ethnicity = value as Ethnicity;
    if (ethnicity === Ethnicity.AMERICA) {
      return 'Nativo americano';
    }
    else if (ethnicity === Ethnicity.CAUCASIAN) {
      return 'Caucasica';
    }
    else if (ethnicity === Ethnicity.ETHIOPIAN) {
      return 'Etiope';
    }
    else if (ethnicity === Ethnicity.MALAY) {
      return 'Malese';
    }
    else if (ethnicity === Ethnicity.MONGOLIAN) {
      return 'Mongola';
    }
    return 'Non specificata';
  }

}
